// Medida (kg / L) dos itens de pedido nas telas do painel (30/09/2026). O item
// gravado no pedido não guarda a unidade de venda: este hook carrega o cadastro
// de produtos (cache de utils/cupomFormatters.getAllProductsCached) e devolve
// `medida(item)` → "kg" | "L" | null, pela regra de lib/unidadeVenda.
// Enquanto o cadastro não chega (ou fora do painel, sem login), vale o que o
// próprio item traz — quantidade quebrada ainda sai com as casas certas.
import { useCallback, useEffect, useState } from "react";

import { medidaDoItem } from "../lib/unidadeVenda";
import { getAllProductsCached } from "../utils/cupomFormatters";

export function useMedidaDoItem(produtosDaTela) {
  const [produtos, setProdutos] = useState(null);
  const temLista = Array.isArray(produtosDaTela) ? produtosDaTela.length > 0 : !!produtosDaTela;
  useEffect(() => {
    if (temLista) return undefined;
    let vivo = true;
    getAllProductsCached().then((lista) => { if (vivo) setProdutos(Array.isArray(lista) ? lista : []); }).catch(() => {});
    return () => { vivo = false; };
  }, [temLista]);
  const fonte = temLista ? produtosDaTela : produtos;
  return useCallback((item) => medidaDoItem(item, fonte), [fonte]);
}
